<div
	*ngIf="(gamblingSummary$ | async) as gamblingSummary"
	[innerHTML]="'regulatory-bar.gambling-summary.description' | translate: gamblingSummary"
></div>
